var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _g3, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessengerGroupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 100,
    fill: "none",
    viewBox: "0 0 163 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#messenger-groupe_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12B76A",
    d: "M45.5 54.396c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M45.5 55.146c13.669 0 24.75-11.08 24.75-24.75 0-13.669-11.081-24.75-24.75-24.75s-24.75 11.081-24.75 24.75c0 13.67 11.081 24.75 24.75 24.75z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#12B76A",
    d: "M55.5 29.396c0 5.8-4.701 10.5-10.5 10.5-2.212 0-4.264-.684-5.956-1.852l-3.59.898.941-3.527a10.452 10.452 0 01-1.895-6.019c0-5.799 4.701-10.5 10.5-10.5s10.5 4.701 10.5 10.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M45 41.646c6.766 0 12.25-5.484 12.25-12.25 0-6.765-5.484-12.25-12.25-12.25s-12.25 5.485-12.25 12.25c0 2.197.578 4.26 1.591 6.042l-1.591 6.208 6.4-1.484A12.196 12.196 0 0045 41.646zm0-1.884c5.725 0 10.365-4.641 10.365-10.366 0-5.724-4.64-10.365-10.365-10.365-5.725 0-10.365 4.64-10.365 10.365 0 2.21.691 4.26 1.87 5.942l-.928 3.481 3.543-.885A10.318 10.318 0 0045 39.762z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.938 23.709c-.292-.585-.739-.534-1.19-.534-.807 0-2.064.967-2.064 2.765 0 1.474.649 3.087 2.837 5.5 2.112 2.33 4.887 3.534 7.19 3.493 2.305-.04 2.779-2.023 2.779-2.693 0-.296-.184-.444-.311-.485-.785-.376-2.233-1.078-2.563-1.21-.33-.132-.501.046-.608.143-.299.285-.891 1.124-1.094 1.313-.203.189-.505.093-.63.022-.464-.186-1.719-.744-2.72-1.714-1.237-1.2-1.31-1.613-1.543-1.98-.186-.294-.05-.474.02-.553.266-.308.634-.782.799-1.018.165-.236.034-.595-.045-.818-.338-.96-.625-1.763-.858-2.231z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#messenger-groupe_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A5AF8",
    d: "M117.5 54.396c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M117.5 55.146c13.669 0 24.75-11.08 24.75-24.75 0-13.669-11.081-24.75-24.75-24.75s-24.75 11.081-24.75 24.75c0 13.67 11.081 24.75 24.75 24.75z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A5AF8",
    d: "M118 39.7c-.706 0-1.367-.024-1.987-.074l-2.964 3.495a.374.374 0 01-.659-.242v-3.987c-3.49-1.31-4.676-4.24-4.676-8.987 0-6.714 2.374-9.795 10.286-9.795 7.912 0 10.286 3.08 10.286 9.795S125.912 39.7 118 39.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFF",
    fillRule: "evenodd",
    d: "M130 29.863c0-7.86-2.769-11.467-12-11.467s-12 3.606-12 11.467c0 5.595 1.403 9.035 5.538 10.553v2.647c0 .974 1.223 1.419 1.856.675l2.134-2.507c.767.067 1.59.1 2.472.1 9.231 0 12-3.606 12-11.468zm-13.962 9.56c.612.049 1.265.073 1.962.073 7.811 0 10.154-3.03 10.154-9.633s-2.343-9.632-10.154-9.632-10.154 3.029-10.154 9.632c0 4.668 1.171 7.55 4.616 8.838v3.921c0 .342.428.498.651.237l2.925-3.436z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFF",
    d: "M118.276 22.682c-.259 0-.47.198-.47.442 0 .245.211.443.47.443 3.116 0 5.641 2.377 5.641 5.308 0 .245.21.443.47.443s.47-.198.47-.443c0-3.42-2.946-6.193-6.581-6.193zm-6.016 1.443c.266-.129.735-.194 1.004.042.336.295.855.811 1.211 1.262.356.451.854 1.138.925 1.29.071.153.15.694-.206 1.02a4.776 4.776 0 01-.806.576.74.74 0 00-.167.888c.254.541.799 1.602 1.741 2.393.941.79 1.938 1.207 2.563 1.339.04 0 .091.009.15.02.212.036.527.091.799-.18.279-.277.533-.569.625-.68.145-.147.567-.4 1.092-.221.656.222 1.408.707 1.748.936.272.183.878.617 1.147.812a.744.744 0 01.222.93c-.269.575-1.416 1.844-2.445 1.844-.379 0-4.05-.978-7.294-3.739-2.071-1.763-3.855-4.823-4.161-5.854-.116-.245-.253-.85.127-1.304.38-.455.807-.93 1.725-1.374zm6.016 2.096c-.259 0-.47.198-.47.442 0 .245.211.443.47.443 1.039 0 1.881.792 1.881 1.77 0 .244.21.442.47.442.259 0 .47-.198.47-.443 0-1.465-1.263-2.654-2.821-2.654z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFF",
    d: "M117.806 24.894c0-.244.211-.442.47-.442 2.596 0 4.701 1.98 4.701 4.423 0 .245-.21.443-.47.443s-.47-.198-.47-.443c0-1.954-1.684-3.539-3.761-3.539-.259 0-.47-.198-.47-.442z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#messenger-groupe_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E90FA",
    d: "M81.5 58.396c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M81.5 59.146c15.878 0 28.75-12.872 28.75-28.75S97.378 1.646 81.5 1.646s-28.75 12.872-28.75 28.75 12.872 28.75 28.75 28.75z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M66.174 30.1c8.163-3.556 13.606-5.9 16.33-7.033 7.775-3.234 9.391-3.796 10.444-3.815.232-.004.75.054 1.085.326.284.23.361.54.399.758.037.218.083.715.046 1.103-.42 4.427-2.244 15.171-3.172 20.13-.392 2.098-1.165 2.802-1.913 2.87-1.626.15-2.861-1.074-4.436-2.106-2.464-1.616-3.856-2.621-6.248-4.198-2.765-1.821-.973-2.823.602-4.459.413-.428 7.577-6.945 7.716-7.536.017-.074.033-.35-.13-.495-.164-.145-.406-.096-.58-.056-.247.056-4.184 2.658-11.81 7.806-1.118.768-2.13 1.142-3.037 1.122-1-.022-2.923-.565-4.353-1.03-1.753-.57-3.147-.871-3.026-1.84.064-.504.758-1.02 2.083-1.546z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "messenger-groupe_svg__a",
    width: 91,
    height: 91,
    x: 0,
    y: 4.896,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 4,
    result: "effect1_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 4,
    result: "effect2_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2691_110339",
    result: "effect2_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2691_110339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "messenger-groupe_svg__b",
    width: 91,
    height: 91,
    x: 72,
    y: 4.896,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 4,
    result: "effect1_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 4,
    result: "effect2_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2691_110339",
    result: "effect2_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2691_110339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "messenger-groupe_svg__c",
    width: 99,
    height: 99,
    x: 32,
    y: 0.896,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 4,
    result: "effect1_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 4,
    result: "effect2_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2691_110339",
    result: "effect2_dropShadow_2691_110339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2691_110339",
    result: "shape"
  })))));
}

export default SvgMessengerGroupe;